import { flattenObject } from './InputComponents/utils'

import messages from '../../constants/validation_messages'
import avaiablePostalCodes from '../../constants/postal_codes'
import prices from '../../constants/form_prices'

const moment = require('moment')

const charsValidator = (values, formStrings) => {
  const errors = {}
  const msg = messages[formStrings.locale]

  /* Gender required */
  if (!values.gender) errors.gender = msg.required

  /* Age required */
  if (!values.age) errors.age = msg.required

  /* Characteristic required and max 3 */
  const charKeys = Object.keys(values.characteristics)
  const charsChecked = charKeys.reduce(
    (acc, p) => acc + (values.characteristics[p] ? 1 : 0),
    0
  )
  if (charKeys.length === 0 || charsChecked > 3 || charsChecked === 0) {
    errors.characteristics = msg.required_max3
  }

  return errors
}

const bouquetValidator = (values, formStrings) => {
  const errors = {}
  const msg = messages[formStrings.locale]

  /* Shape required */
  if (!values.shape) {
    errors.shape = msg.required
  }

  /* Size required */
  if (!values.size) {
    errors.size = msg.required
  }

  /* Specific size required if it's chosen */
  if (values.size === formStrings.bouquet.size.values[3]) {
    if (!values.specific_size) {
      errors.specific_size = msg.required
    } else if (parseInt(values.specific_size) < 101) {
      errors.specific_size = msg.specific_size
    }
  }

  /* Color required and max 3 */
  const bouquetKeys = Object.keys(values.color)
  const colorsChecked = bouquetKeys.reduce(
    (acc, p) => acc + (values.color[p] ? 1 : 0),
    0
  )
  if (bouquetKeys.length === 0 || colorsChecked > 3 || colorsChecked === 0) {
    errors.color = msg.required_max3
  }

  return errors
}

const cardValidator = (values, formStrings) => {
  const errors = {}
  const msg = messages[formStrings.locale]

  /* Card required */
  if (!values.card) {
    errors.card = msg.required
  } else if (
    values.card === formStrings.card.card.values[0] &&
    values.card_text === ''
  ) {
    errors.card_text = msg.required
  }
  return errors
}

const deliveryValidator = (values, formStrings, validation) => {
  const errors = { address: {} }
  const msg = messages[formStrings.locale]

  // Standard delivery method chosen
  if (values.method === formStrings.delivery.method.values[0]) {
    /* Delivery required fields validator */
    if (!values.address.given_name) {
      errors.address.given_name = msg.required
    }
    if (!values.address.family_name) {
      errors.address.family_name = msg.required
    }
    if (!values.address.street) {
      errors.address.street = msg.required
    }
    if (!values.address.house_number) {
      errors.address.house_number = msg.required
    }
    if (!values.address.postal_code) {
      errors.address.postal_code = msg.required
    } else if (
      // only avaiable postal codes
      !Object.keys(avaiablePostalCodes)
        .map(key =>
          avaiablePostalCodes[key].includes(
            parseInt(values.address.postal_code)
          )
        )
        .includes(true)
    ) {
      errors.address.postal_code =
        validation.inaccessibleLocationValidationMessage
    }
    if (!values.address.city) {
      errors.address.city = msg.required
    }
    if (!values.address.tel) {
      errors.address.tel = msg.required
    } else if (!/^\d+$/.test(values.address.tel)) {
      errors.address.tel = msg.required
    }
    if (
      values.address.email &&
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.address.email)
    ) {
      errors.address.email = msg.email
    }

    if (!values.time) {
      errors.time = msg.required
    }

    /* Specific time validator - between 8 and 20 */
    if (values.time === formStrings.delivery.time.values[4]) {
      if (!values.specific_time) {
        errors.specific_time = msg.required
      } else {
        const s = values.specific_time.split(':')
        const time = 60 * parseInt(s[0]) + parseInt(s[1])
        if (time < 480 || time > 1200) {
          errors.specific_time = msg.between8and20
        }
      }
    }

    // chosen delivery time can't be lest than 24h from now
    if (values.time && values.date) {
      const time = ['10:00', '12:00', '14:00', '16:00', values.specific_time][
        formStrings.delivery.time.values.indexOf(values.time)
      ]

      let date = moment(`${values.date} ${time || ''}`)
      if (date.isBefore(moment().add(24, 'h'))) {
        errors.date = validation.moreThan24hValidationMessage
        if (date.isBefore(moment())) {
          errors.date = validation.dateInFutureValidationMessage
        }
      } else if (date.day() === 0) {
        errors.date = validation.sundayValidationMessage
      } else {
        const vacation = validation.vacationDays
        vacation.forEach(e => {
          const [day, month] = e.split('.')
          if (
            date.date() === parseInt(day) &&
            date.month() === parseInt(month) - 1
          ) {
            errors.date = validation.vacationValidationMessage
          }
        })
      }
    }
  } else {
    // Pick-up chosen
    /* Pick-up time validator - required and between 10 and 20 */
    if (!values.pickup_time) {
      errors.pickup_time = msg.required
    } else {
      const s = values.pickup_time.split(':')
      const time = 60 * parseInt(s[0]) + parseInt(s[1])
      if (time < 600 || time > 1200) {
        errors.pickup_time = msg.between10and20
      }
    }
    // chosen delivery time can't be less than 24 h
    if (values.pickup_time && values.date) {
      let date = moment(`${values.date} ${values.pickup_time || ''}`)
      if (date.isBefore(moment().add(24, 'h'))) {
        errors.date = validation.moreThan24hValidationMessage
        if (date.isBefore(moment())) {
          errors.date = validation.dateInFutureValidationMessage
        }
      } else if (date.day() === 0) {
        errors.date = validation.sundayValidationMessage
      } else {
        const vacation = validation.vacationDays
        vacation.forEach(e => {
          const [day, month] = e.split('.')
          if (
            date.date() === parseInt(day) &&
            date.month() === parseInt(month) - 1
          ) {
            errors.date = validation.vacationValidationMessage
          }
        })
      }
    }
  }

  /* Date validator - can't be in the past, during vacation and sunday */
  if (!values.date) {
    errors.date = msg.required
  }

  if (values.date && !values.time) {
    const now = moment()
    const date = moment(values.date)
    if (date.isBefore(now)) {
      errors.date = validation.dateInFutureValidationMessage
    }
  }

  return errors
}

const paymentValidator = (values, formStrings) => {
  const errors = { address: {} }
  const msg = messages[formStrings.locale]

  /* Payments validator */
  if (!values.address.given_name) {
    errors.address.given_name = msg.required
  }
  if (!values.address.family_name) {
    errors.address.family_name = msg.required
  }
  if (!values.address.street) {
    errors.address.street = msg.required
  }
  if (!values.address.house_number) {
    errors.address.house_number = msg.required
  }
  if (!values.address.postal_code) {
    errors.address.postal_code = msg.required
  }
  if (!values.address.city) {
    errors.address.city = msg.required
  }
  if (!values.address.tel) {
    errors.address.tel = msg.required
  } else if (!/^\d+$/.test(values.address.tel)) {
    errors.address.tel = msg.required
  }
  if (!values.address.email) {
    errors.address.email = msg.required
  } else if (
    !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.address.email)
  ) {
    errors.address.email = msg.email
  }

  /* Payment method validator */
  if (!values.method) {
    errors.method = msg.required
  }

  return errors
}

const summaryValidator = (values, formStrings) => {
  const errors = {}
  const msg = messages[formStrings.locale]

  /* Terms required */
  if (!values.terms) errors.terms = msg.required

  return errors
}

export const getInfo = (values, formStrings, validation) => {
  const info = {}
  const msg = messages[formStrings.locale]

  /* Less than 48h delivery */
  if (values.delivery && values.delivery.date) {
    if (values.delivery.method === formStrings.delivery.method.values[0]) {
      // Standard delivery method chosen
      if (!values.delivery.time) {
        // time not chosen yet
        if (
          moment(values.delivery.date).date() ===
          moment()
            .add(1, 'd')
            .date()
        ) {
          info.date = validation.urgentDeliveryMessage
        }
      } else {
        // time chosen
        const times = [
          '10:00',
          '12:00',
          '14:00',
          '16:00',
          values.delivery.specific_time
        ]
        const i = [
          formStrings.delivery.time.values.indexOf(values.delivery.time)
        ]

        let date = moment(`${values.delivery.date} ${times[i] || ''}`)
        let now = moment()
        let urgentDeliveryThreshold = moment().add(48, 'h')
        if (now.weekday() === 0 || now.weekday() === 6) {
          urgentDeliveryThreshold.add(24, 'h')
        }
        if (date.isBefore(urgentDeliveryThreshold) && date.isAfter(moment())) {
          info.date = validation.urgentDeliveryMessage
        }
      }
    } else {
      // Self pick-up chosen
      if (!values.delivery.pickup_time) {
        // time not chosen yet
        if (
          moment(values.delivery.date).date() ===
          moment()
            .add(1, 'd')
            .date()
        ) {
          info.date = validation.urgentDeliveryMessage
        }
      } else {
        // time chosen
        let date = moment(
          `${values.delivery.date} ${values.delivery.pickup_time || ''}`
        )
        let now = moment()
        let urgentDeliveryThreshold = moment().add(48, 'h')
        if (now.weekday() === 0 || now.weekday() === 6) {
          urgentDeliveryThreshold.add(24, 'h')
        }
        if (date.isBefore(urgentDeliveryThreshold) && date.isAfter(moment())) {
          info.date = validation.urgentDeliveryMessage
        }
      }
    }
  }

  // Rush hour info
  if (values.delivery.specific_time) {
    const s = values.delivery.specific_time.split(':')
    const time = 60 * parseInt(s[0]) + parseInt(s[1])
    if (time >= 18 * 60 && time <= 20 * 60) {
      info.time = msg.rush_hour
    }
  }

  return info
}

export const calculatePrice = (values, formStrings) => {
  const pricesObj = {}

  // bouquet size
  if (values.bouquet.size) {
    const sizes = formStrings.bouquet.size.values
    const chosenSize = values.bouquet.size
    if (chosenSize === sizes[0]) {
      pricesObj.bouquet = prices.bouquet.standard
    } else if (chosenSize === sizes[1]) {
      pricesObj.bouquet = prices.bouquet.medium
    } else if (chosenSize === sizes[2]) {
      pricesObj.bouquet = prices.bouquet.large
    } else if (chosenSize === sizes[3]) {
      pricesObj.bouquet = values.bouquet.specific_size || 0
    }
  }

  // extra card
  if (
    values.card.card &&
    values.card.card === formStrings.card.card.values[0]
  ) {
    pricesObj.card = prices.card
  } else {
    pricesObj.card = 0
  }

  if (values.delivery.method === formStrings.delivery.method.values[0]) {
    // life zone
    if (values.delivery.address.postal_code) {
      Object.keys(avaiablePostalCodes).forEach(key => {
        if (
          avaiablePostalCodes[key].includes(
            parseInt(values.delivery.address.postal_code)
          ) &&
          !pricesObj.life_zone
        ) {
          pricesObj.life_zone = prices.life_zone[key]
        }
      })
    }

    // specific time
    if (values.delivery.time === formStrings.delivery.time.values[4]) {
      pricesObj.specific_time = prices.delivery.specific_time

      // rush hour - between 18 and 20
      if (values.delivery.specific_time) {
        const s = values.delivery.specific_time.split(':')
        const time = 60 * parseInt(s[0]) + parseInt(s[1])
        if (time > 18 * 60 && time < 20 * 60) {
          pricesObj.rush_hour = prices.delivery.rush_hour
        }
      }
    }

    // urgent delivery
    if (values.delivery.date && values.delivery.time) {
      const time = [
        '10:00',
        '12:00',
        '14:00',
        '16:00',
        values.delivery.specific_time
      ][formStrings.delivery.time.values.indexOf(values.delivery.time)]

      let date = moment(`${values.delivery.date} ${time || ''}`)
      let now = moment()
      let urgentDeliveryThreshold = moment().add(48, 'h')
      if (now.weekday() === 0 || now.weekday() === 6) {
        urgentDeliveryThreshold.add(24, 'h')
      }
      if (date.isBefore(urgentDeliveryThreshold) && date.isAfter(moment())) {
        pricesObj.urgent_delivery = prices.urgent_delivery
      }
    }
  } else {
    // time chosen
    pricesObj.pickup_time = prices.pickup_time

    let date = moment(
      `${values.delivery.date} ${values.delivery.pickup_time || ''}`
    )
    let now = moment()
    let urgentDeliveryThreshold = moment().add(48, 'h')
    if (now.weekday() === 0 || now.weekday() === 6) {
      urgentDeliveryThreshold.add(24, 'h')
    }
    if (date.isBefore(urgentDeliveryThreshold) && date.isAfter(moment())) {
      pricesObj.urgent_delivery = prices.urgent_delivery
    }
  }

  return pricesObj
}

export default (values, formStrings, validation, stage) => {
  const errors = {}
  if (stage >= 1) {
    errors.chars = charsValidator(values.chars, formStrings)
  }
  if (stage >= 2) {
    errors.bouquet = bouquetValidator(values.bouquet, formStrings)
  }
  if (stage >= 3) {
    errors.card = cardValidator(values.card, formStrings)
  }
  if (stage >= 4) {
    errors.delivery = deliveryValidator(
      values.delivery,
      formStrings,
      validation
    )
  }
  if (stage >= 5) {
    errors.payment = paymentValidator(values.payment, formStrings)
  }
  if (stage >= 6) {
    errors.summary = summaryValidator(values.summary, formStrings)
  }

  return Object.keys(flattenObject(errors)).length === 0 ? {} : errors
}
